import { render, staticRenderFns } from "./MollieBilling.vue?vue&type=template&id=4adde6b2&scoped=true"
import script from "./MollieBilling.vue?vue&type=script&lang=js"
export * from "./MollieBilling.vue?vue&type=script&lang=js"
import style0 from "./MollieBilling.vue?vue&type=style&index=0&id=4adde6b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4adde6b2",
  null
  
)

export default component.exports